import api from '../client';

export const AdminService = {
  getIntegrations: () => api.get('/admin/integrations'),
  getIntegration: (serviceKey) => api.get(`/admin/integrations/${serviceKey}`),
  createOrUpdateIntegration: (serviceKey, data) => api.post(`/admin/integrations/${serviceKey}`, data),
  deleteIntegration: (serviceKey) => api.delete(`/admin/integrations/${serviceKey}`),
};
